import {RATE_LIMIT_FALLBACK_S} from "../constants/reservation_constants";
import {IReservationError} from "../types/IReservationError";
import {IHandleState} from "../types/ReservationFlowState";

// All timestamps are epoch milliseconds

// whole seconds left until the timestamp, rounded up; 0 once it has passed or when there is none
export const secondsUntil = (timestamp: number | null, now: number): number =>
    timestamp !== null && timestamp > now ? Math.ceil((timestamp - now) / 1000) : 0;

export const isLocked = (state: IHandleState, now: number): boolean => state.lockedUntil !== null && now < state.lockedUntil;

// the end of a rate limit - Retry-After, or the fallback lock when the 429 came without it
export const getLockedUntil = (error: IReservationError, now: number): number => now + (error.retryAfterSeconds ?? RATE_LIMIT_FALLBACK_S) * 1000;
import {RATE_LIMIT_FALLBACK_S} from "../constants/reservation_constants";
import {IReservationError} from "../types/IReservationError";
import {IHandleState} from "../types/ReservationFlowState";

// All timestamps are epoch milliseconds

// whole seconds left until the timestamp, rounded up; 0 once it has passed or when there is none
export const secondsUntil = (timestamp: number | null, now: number): number =>
    timestamp !== null && timestamp > now ? Math.ceil((timestamp - now) / 1000) : 0;

export const isLocked = (state: IHandleState, now: number): boolean => state.lockedUntil !== null && now < state.lockedUntil;

// the end of a rate limit - Retry-After, or the fallback lock when the 429 came without it
export const getLockedUntil = (error: IReservationError, now: number): number => now + (error.retryAfterSeconds ?? RATE_LIMIT_FALLBACK_S) * 1000;
